<template>
  <b-container>
    <delivery1 side-bar-continue-text="ادامه فرایند رزرو" />
  </b-container>
</template>

<script>
import Delivery1 from '@moeinmdn/miw-components/src/plugin/ShoppingCart/Delivery/Deliver1';

export default {
  name: "Delivery",
  components: {Delivery1}
}
</script>

<style scoped>

</style>